import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "12",
  fill: "none",
  viewBox: "0 0 18 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m6.45 11.85-5.6-5.6 1.075-1.075L6.45 9.7l9.6-9.6 1.075 1.075z"
    }, null, -1)
  ]))]))
}
export default { render: render }